import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Signup from './account/Signup';
import Login from './account/Login';
import ForgetPassword from './account/ForgetPassword';
import Leads from './leads/Leads';
import Verify from './account/Verification';
import Logout from './account/Logout';
import Plan from './account/Plan';
import ResetPassword from './account/ResetPassword';
import ImportData from './admin/ImportData';
import Success from './callback/success';
import Fail from './callback/fail';
import UserList from './admin/UserList';
import Visualization from './admin/Visualization';
import PricingPlan from './admin/PricingPlan';
import Settings from './account/Settings';
import DataOverview from './admin/DataOverview';
import Support from './account/Support';
import AuthCallback from './callback/sucess_auth';
import Finder from './leads/Finder';
import Bounce from './bounce/Bounce';
import BounceFile from './bounce/file';
import VerifyResult from './bounce/VerifyResult';
import API from './api/API';
import APIAnalytics from './api/APIAnalytics';
import RapidApiUser from './admin/RapidAPIUser';
import BulkResultPage from './bounce/BulkResultPage';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <div className="zoom-fill-container">
    <Router>
      
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/logout" element={<Logout />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/apiv1/dashboard" element={<API />} />
        <Route path="/apiv1/analytics" element={<APIAnalytics />} />
        <Route path="/apiv1/rapidapi-user" element={<RapidApiUser />} />
        
        <Route path="/auth/success" element={<AuthCallback />} />
        <Route path="/finder" element={<Finder />} />
        <Route path="/verify/email" element={<Bounce />} />
        <Route path="/verify/file" element={<BounceFile />} />
        <Route path="/verify/result/:id" element={<VerifyResult />} />
        <Route path="/verify/bulk-result/:id" element={<BulkResultPage />} />
        
        <Route path="/:email_verify/verify" element={<Verify />} />
        <Route path="/login" element={<Login />} />
        <Route path="/forget-password" element={<ForgetPassword />} />
        <Route path="/leads" element={<Leads />} />
        <Route path="/plans" element={<Plan />} />
        <Route path="/:email/reset-password" element={<ResetPassword />} />
        <Route path="/admin/import-data" element={<ImportData />} />
        <Route path="/callback/success" element={<Success />} />
        <Route path="/callback/fail" element={<Fail />} />
        <Route path="/admin/user-lists" element={<UserList />} />
        <Route path="/admin/data-visualization" element={<Visualization />} />
        <Route path="/admin/pricing-plan" element={<PricingPlan />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/admin/data-overview" element={<DataOverview />} />
        <Route path="/support" element={<Support />} />
      </Routes>
     
    </Router>
    </div>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
